import { AuthGuard } from '@/components/auth/auth-guard';
import { AppLayout } from '@/components/layout';
import { AbsencesPageHeader } from '@/features/absences/components/absences-page-header';
import { ScheduleView } from '@/features/absences/components/schedule/schedule-view';
import { useAuthStore } from '@/stores/auth';
import { hasPlaceholderPermission } from '@/lib/permissions';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/absences/schedule')({
  beforeLoad: async () => {
    const { isAuthenticated, isInitialized } = useAuthStore.getState();
    if (!isInitialized) return;
    if (!isAuthenticated) throw redirect({ to: '/login' });

    const user = useAuthStore.getState().user;
    if (hasPlaceholderPermission(user)) throw redirect({ to: '/placeholder' });
  },
  component: AbsencesSchedulePage,
});

function AbsencesSchedulePage() {
  return (
    <AuthGuard>
      <AppLayout>
        <AbsencesPageHeader />
        <div className="min-h-full animate-fade-in">
          <ScheduleView />
        </div>
      </AppLayout>
    </AuthGuard>
  );
}
